import './report-featured-list.scss'

import { pluck, tap } from 'rxjs/operators'
import { defineComponent } from 'vue'

import { ReportFeatured, ConditionReport } from '@skinsoft/types'
import { conditionReportSelectors } from '@skinsoft/selectors'
import { toReportFeaturedFromSearch$ } from '@skinsoft/entity-ui'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { NB_REPORTS_SEARCH_RESULT_CHANGED_TOPIC } from '@skinsoft/bus'
import { ReportfeaturedCard } from '../report-featured-card'


const REPORT_FEATURED_ITEM_COUNT = 5;

export const ReportFeaturedList = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sReportFeaturedCard: ReportfeaturedCard
    },
    props: ['listState', 'searchParams', 'emptyMessage', 'titleClickAction'],
    template: require("./report-featured-list.html"),
    data() {
        return {
            // the list used to populate UI
            reportFeatureds: [] as ReportFeatured[],
            // the list used to filter retrieved data
            filteredReportFeatured: [] as ReportFeatured[],
            totalResults: 0,
        }
    },
    watch: {
        searchParams: {
            handler() {
                // Testing all search params presence to avoid useless search query during params setting
                if (this.searchParams.nbResults && this.searchParams.sortType?.length) {
                    this.unsubscribe();
                    this.reportFeatureds = Array(REPORT_FEATURED_ITEM_COUNT).fill(null);
                    this.$emit('totalCount', null);
                    this.subscribe();
                }
            },
            immediate: true,
            deep: true,
        },
    },
    methods: {
        subscribe() {
            const sortObject =
                this.searchParams?.sortType?.length > 0
                    ? { entityFields: this.searchParams.sortType, sortAsc: this.searchParams.sortAsc }
                    : null


            let advancedSearches = [
                {
                    // filtering to keep only reports linked to an item
                    leftCriteria: {
                        entityField: "5f32925d9393981d6dd60ebd",
                        operator: "exists",
                        type: "criteria",
                        value: {
                            completeSearch: false,
                            refId: null,
                            type: "ref"
                        },
                    },
                    linkOperator: "AND",
                    // filtering field (on status)
                    rightCriteria: {
                        entityField: "5e7b836714256b1944f069fa",
                        operator: "equals",
                        type: "criteria",
                        value: {
                            text: this.listState,
                            type: "text"
                        },
                    },
                    type: "requestSearch",
                }
            ]

            let request$ = this.$conditionReportDataStore.searchAll(
                {
                    queryText: this.searchParams.queryText,
                    sortObject: sortObject,
                    pageSize: this.searchParams.nbResults,
                    advancedSearches: advancedSearches,
                }
            )

            if(!window.navigator.onLine) {
                (advancedSearches[0] as any).rightCriteria = {
                    leftCriteria: {
                        entityField: "5e7b836714256b1944f069fa",
                        operator: "equals",
                        type: "criteria",
                        value: {
                            text: this.listState,
                            type: "text"
                        },
                    },
                    linkOperator: "OR",
                    rightCriteria: {
                        entityField: "_conditionReportCurrentState",
                        operator: "equals",
                        type: "criteria",
                        value: {
                            text: this.listState,
                            type: "text"
                        },
                    }
                }

                request$ = this.$conditionReportDataStore.searchAllOffline(
                    {
                        queryText: this.searchParams.queryText,
                        sortObject: sortObject,
                        pageSize: this.searchParams.nbResults,
                        advancedSearches: advancedSearches,
                    }
                )
            }


            this.subscribeTo(
                request$.pipe(
                        tap(results => {
                            this.totalResults = results.totalSize
                        }),
                        pluck('allData')
                    ),
                (reports: ConditionReport[]) => {
                    reports.map(report => {
                        const reportState = conditionReportSelectors.workflowState(report);
                        toReportFeaturedFromSearch$(report, this.getAppLocale()).subscribe(featured => {
                            this.filteredReportFeatured.push(featured)
                        })
                    })

                    // Retrieving filtered reports to display them
                    this.reportFeatureds = this.filteredReportFeatured;
                    this.filteredReportFeatured = [];
                    this.emitOnBus(NB_REPORTS_SEARCH_RESULT_CHANGED_TOPIC, { totalResults: this.totalResults })
                }
                , 'reportFeatureds'
            )
        },
        unsubscribe() {
            this.unsubscribeFrom('reportFeatureds');
        },
    },
})
